import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    output,
    signal,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { LocalStorageService } from '@interacta-shared/data-access-common';
import {
    ConfigurationService,
    ENVIRONMENT,
} from '@interacta-shared/data-access-configuration';
import {
    DialogButtonComponent,
    DialogButtonsComponent,
    DialogComponent,
    ToggleComponent,
} from '@interacta-shared/ui';
import { openSourceLicenses } from '@modules/app-routing/routes';
import { DEVTOOLS_STORAGE_KEY } from '@modules/core/helpers/store-devtools.utils';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-app-info-dialog',
    imports: [
        DialogButtonsComponent,
        DialogButtonComponent,
        DialogComponent,
        RouterLink,
        ToggleComponent,
        TranslatePipe,
    ],
    templateUrl: './app-info-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppInfoDialogComponent {
    private readonly info = inject(ConfigurationService);
    private readonly localStorage = inject(LocalStorageService);
    private readonly environment = inject(ENVIRONMENT);

    readonly openSourceLicenses = openSourceLicenses;
    readonly isOpen = input.required<boolean>();
    readonly closing = output<void>();
    readonly isProduction = this.environment.production;

    readonly devtoolsEnabled = signal(
        this.localStorage.getEntry<boolean>(DEVTOOLS_STORAGE_KEY, false) ??
            false,
    );
    readonly showReloadDialog = signal(false);

    readonly backendVersion = computed(
        () => this.info.environmentInfo()?.buildInfo.backend.version ?? '',
    );

    readonly frontendVersion = computed(
        () => this.info.environmentInfo()?.buildInfo.frontend.version ?? '',
    );

    readonly customerPlugin = computed(() =>
        this.info
            .environmentInfo()
            ?.buildInfo.backend.loadedPlugins?.find(({ id }) =>
                id.startsWith('interacta-plugin-customer'),
            ),
    );

    onDevtoolsToggle(enabled: boolean): void {
        this.localStorage.setEntry(DEVTOOLS_STORAGE_KEY, enabled, false);
        this.devtoolsEnabled.set(enabled);
        this.showReloadDialog.set(true);
    }

    onReload(): void {
        window.location.reload();
    }
}
